<template>
  <section>
    <h1 class="section-head">รายการสั่งซื้อผลิตภัณฑ์</h1>
    <div class="columns">
      <div class="column">
        
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <app-purchaseorder></app-purchaseorder>
      </div>
    </div>
  </section>
</template>

<script>
  import PurchaseOrder from '@/components/purchase_order';
  export default {
    components: {
      "app-purchaseorder": PurchaseOrder
    },
    data() {
      return {
        orders: [],
      }
    },
    mounted(){
      
    }

  }
</script>


// WEBPACK FOOTER //
// src/pages/PurchaseOrder/index.vue